export default __webpack_public_path__ + "static/media/partner-austria-wien.d165f1e9.webp";